module.exports = __webpack_public_path__ + "img/house.223e38a7.svg";